import { Attrs, MinzeElement } from 'minze'

export interface LvcArrowRightIcon {
  dataColor?: string
  width?: number
  height?: number
}

export class LvcArrowRightIcon extends MinzeElement {
  attrs: Attrs = [['data-color'], ['width', '45'], ['height', '14']]

  html = () => `
<svg width="${this.width}" height="${this.height}" viewBox="0 0 45 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M31.3864 7.12531C29.082 7.16151 26.9653 7.1799 24.8369 7.23109C19.4885 7.35294 14.1288 7.48556 8.78008 7.61843C6.87225 7.66357 4.96441 7.70872 3.05708 7.73183C2.54983 7.74243 2.03205 7.73076 1.53879 7.60941C1.08935 7.50008 0.73402 7.12833 0.866382 6.63533C0.950454 6.32861 1.21178 5.98179 1.49067 5.83378C1.79209 5.66422 2.1997 5.67342 2.56374 5.65958C4.17462 5.5857 5.78551 5.51181 7.40642 5.48224C15.1036 5.31416 22.8113 5.16837 30.5082 5.01131C30.7839 5.00651 31.0723 4.92484 31.3487 4.88698C31.795 4.15857 31.5805 3.40424 31.6405 2.70018C31.685 2.19417 31.6967 1.67639 31.818 1.18314C31.9399 0.667851 32.7425 0.267117 33.235 0.421512C33.4431 0.481315 33.6614 0.574416 33.8349 0.699573C36.5781 2.71235 39.6785 4.03879 42.755 5.44185C43.3442 5.70864 43.9204 6.06332 44.4405 6.46082C44.9929 6.89212 44.9617 7.78421 44.4015 8.19041C43.9869 8.48967 43.519 8.71058 43.0513 8.92048C40.2133 10.135 37.4076 11.3834 34.7381 12.9434C34.2467 13.2299 33.6694 13.4153 33.1046 13.5348C32.4621 13.6746 31.8877 13.2428 32.0133 12.5623C32.1891 11.6073 31.4551 10.9184 31.5306 10.0163C31.6056 9.13626 31.6805 8.25619 31.3864 7.12531Z" fill="#1E007D"/>
</svg>

    
  
  `

  css = () => `
    :host {
      width: ${this.width}px;
      height: ${this.height}px;
      display:flex;
      align-items:center;
    }
  `
}
